import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CaseItem } from '@root/app/shared/models/case-item.model';
import { Case } from '@shared/models/case.model';
import { User } from '@shared/models/user.model';
import {BehaviorSubject, lastValueFrom, Observable, Subject} from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantService } from '@root/app/shared/services';



@Injectable({
  providedIn: 'root'
})
export class CaseService {
  public case$: Subject<any> = new Subject<any>();
  public uploadCallbackUrl$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private displayLoader: boolean = true;
  constructor(private http: HttpClient, private tenantService: TenantService) { }

  public baseUrlApi = this.tenantService.getParameter("sorrento", "baseUrlApi");
  public basePathApi = this.tenantService.getParameter("sorrento", "basePathApi");

  getCase(caseId: string): void {
    const getCaseApiUrl = `${this.baseUrlApi}/${this.basePathApi}/cases/${caseId}`;
    this.http.get<any>(getCaseApiUrl).pipe(
      map((response: any) => new Case(
        response.validSeconds,
        response.redirectUrl,
        response.status,
        response.name,
        response.users.map(user => new User(
          user.firstName,
          user.familyName,
          user.nrOfAllowedAdditionalDocs,
          user.masterId,
          user.entryId,
          user.creationTime,
          user.updateTime,
          user.currentVersion,
          user.caseItems
            .map((caseItem, index: number) => new CaseItem(
              caseItem.masterId,
              caseItem.entryId,
              caseItem.creationTime,
              caseItem.updateTime,
              caseItem.currentVersion,
              caseItem.class,
              caseItem.name,
              response.typeLocked,
              caseItem.type,
              caseItem.presignedUrls,
              caseItem.s3Objects,
              caseItem.serviceStatuses,
              caseItem.retriesPerPage,
              caseItem.status,
              caseItem.recognisedData,
              caseItem.confirmedData,
              caseItem.review,
              caseItem.maxRetries,
              caseItem.main
            ))
        )),
        response.masterId,
        response.entryId,
        response.creationTime,
        response.updateTime,
        response.currentVersion,

      ))
    ).subscribe((ret) => {
      this.case$.next(ret);
      this.uploadCallbackUrl$.next(ret.redirectUrl);
    });
  }


  // updates the case, value modified here is the status of the case
  public async updateCase(valueModified: any, caseId: string) {
    const reqUrl = `${this.baseUrlApi}/${this.basePathApi}/cases/${caseId}`;
    return await lastValueFrom(this.http.patch(reqUrl, valueModified)).then(async data => {
      return data;
    });
  }

  public getDisplayLoader() {
    return this.displayLoader;
  }

  public setDisplayLoader(value: boolean) {
    this.displayLoader = value;
  }

  // adds a case-item to caseId
  public addCaseItemToCase(caseId: string, userId: string, classItem: any): Observable<any> {
    classItem.main = false;
    const reqUrl = `${this.baseUrlApi}/${this.basePathApi}/cases/${caseId}/users/${userId}/caseitems`;
    return this.http.post(reqUrl, classItem);
  }

  //
  public removeCaseItemFromCase(caseId: string, userId: string, classItem: any): Observable<any> {
    const reqUrl = `${this.baseUrlApi}/${this.basePathApi}/cases/${caseId}/users/${userId}/caseitems/${classItem}`;
    return this.http.delete(reqUrl);
  }
}


